import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

////https://stackoverflow.com/a/66114907 - under package.json file
////https://stackblitz.com/edit/ng2-pdf-viewer-bootstrap-modal?file=src%2Fapp%2Fapp.component.html
////https://www.npmjs.com/package/ng2-pdf-viewer#install //npm install ng2-pdf-viewer@~3.0.8
//import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PdfViewerNg2Component } from './pdf-viewer-ng2.component';

import { ModalModule } from '../../../../../lib/modal';
@NgModule({
  declarations: [
    PdfViewerNg2Component,
  ],
  imports: [
    CommonModule,
    ModalModule,
    //PdfViewerModule,
  ],
  exports: [
    PdfViewerNg2Component,
  ],
})
export class PdfViewerNg2Module { }
